import React from 'react';
import { Input, Button, Text, Box } from '@chakra-ui/react';
import { ordersByEmail } from '../api';
// import { ExternalLinkIcon } from '@chakra-ui/icons';
import SendEmailButton from '../components/SendEmailButton';

const Result = ({ id, createdAt }) => {
  // const URL =
  //   window.location.hostname === 'localhost'
  //     ? 'http://localhost:3000'
  //     : 'https://' + window.location.hostname;

  const date = new Date(createdAt).toLocaleString('it', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });

  return (
    <Box p={1} my={3} border={'2px solid teal'} borderRadius={5}>
      <Box p={3}>
        {/* <Link color={'gold'} href={URL + '/checkout-ok/' + id} isExternal> */}
        {/* <Text color='gold'>
            {id}
          </Text> */}
        {/* </Link> */}
        <Text mb={3}>Ordine creato il {date}</Text>
        {/* <Text>status {status}</Text> */}
        <SendEmailButton text='Invia ordine via mail' orderId={id} />
      </Box>
    </Box>
  );
};
function EmailInputUser() {
  const [isLoading, setIsLoading] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const [error, setError] = React.useState('');
  const [orders, setOrders] = React.useState([]);
  const handleChange = (event) => {
    setError('');
    setOrders([]);
    setEmail(event.target.value.toLowerCase());
  };

  console.log(orders);
  return (
    <>
      <Input my={5} value={email} onChange={handleChange} placeholder='email@email.com' size='sm' />
      <Button
        isLoading={isLoading}
        isDisabled={!email}
        onClick={async () => {
          setError('');
          setOrders([]);
          setIsLoading(true);
          const data = await ordersByEmail(email);
          // console.log('DATA', data);
          setIsLoading(false);
          if (!data.orders.length) {
            setError('Nessun ordine trovato');
          } else {
            setOrders([...data.orders]);
          }
        }}
      >
        Cerca
      </Button>

      {error && (
        <Text fontSize={'lg'} color='tomato' mt={5}>
          {error}
        </Text>
      )}

      {orders
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .map((order, index) => {
          return <Result key={index} {...order} />;
        })}
    </>
  );
}

export default EmailInputUser;
